import { component } from 'picoapp'
import $ from 'quantdom'
import { centsToDollars, getOutOfStockData, handlize } from '../lib/utils'

export default component(() => {
  const url = `${window.location.origin}${window.location.pathname}`
  let product = window.product
  let variants = window.product.variants
  let threeMonthVariants = window.three_month_product.variants || []
  let sixMonthVariants = window.six_month_product.variants || []

  // inject product id into json
  variants.forEach((variant) => {
    variant.product_id = product.id
  })
  threeMonthVariants.forEach((variant) => {
    variant.product_id = window.three_month_product.id
  })
  sixMonthVariants.forEach((variant) => {
    variant.product_id = window.six_month_product.id
  })

  const allVariants = [...variants, ...threeMonthVariants, ...sixMonthVariants]

  function updateUrlWithVariantId(variantId) {
    let url = new URL(window.location)
    url.searchParams.set('variant', variantId)
    history.replaceState({}, '', url.href)
  }

  if ($(`.quiz-pro-o3`)) {
    $('.js-faq-section').removeClass('tw-hidden')
    $('.js-faq-section').addClass('tw-flex-center')

    document.querySelector('.js-faq-link').addEventListener('click', () => {
      if (document.querySelector('.js-questions-accordion')) {
        document.querySelector('.js-questions-accordion').scrollIntoView({ behavior: 'smooth' })
      } else if (document.querySelector('.quiz-pro-o3')) {
        document.querySelector('.quiz-pro-o3').scrollIntoView({ behavior: 'smooth' })
      } else if (document.querySelector('.WS__faq-simple')) {
        document.querySelector('.WS__faq-simple').scrollIntoView({ behavior: 'smooth' })
      }
    })
  }

  const addUpsellButtonListeners = () => {
    const upsellAddButtons = $('.js-upsell-add-button')
    if (upsellAddButtons && upsellAddButtons.els.length > 0) {
      upsellAddButtons.on('click', (e) => {
        const disableCartToggle = $(e.target).attr('disable-cart-toggle')
        const title = $(e.target).attr('data-title')
        const price = $(e.target).attr('data-price')
        const variantId = $(e.target).attr('data-variant-id')
        const sellingPlanId = $(e.target).attr('data-selling-plan-id')
        if (window?.gtag) {
          gtag('event', `PDP Upsell Added`, {
            event_detail: `${title} - ${price}`,
          })
        }
        window.MicroBus.emit(`cart:add`, {
          variant_id: variantId,
          quantity: 1,
          selling_plan: sellingPlanId,
        })
        if (disableCartToggle === null) {
          window.MicroBus.emit('side-cart:toggle')
        }
      })
    }
  }
  addUpsellButtonListeners()

  const adjustAtfSticky = (stickyObj, galleryHeight, screenHeight) => {
    const headerTop = parseInt(window.getComputedStyle($('#header-2024').els[0]).height)
    if (galleryHeight > screenHeight) {
      stickyObj.els[0].style.top = screenHeight - galleryHeight - 40 + 'px'
    } else {
      stickyObj.els[0].style.top = `${$('#header-2024').els[0].offsetHeight + headerTop + 40}px`
    }
  }

  // Events
  window.onscroll = function () {
    adjustAtfSticky($('.js-sticky-buybox'), $('.js-sticky-buybox').els[0].clientHeight, window.innerHeight)
    adjustAtfSticky(
      $('#product-featured-image-container'),
      $('#product-featured-image-container').els[0].clientHeight,
      window.innerHeight
    )
  }

  window.onresize = function () {
    adjustAtfSticky($('.js-sticky-buybox'), $('.js-sticky-buybox').els[0].clientHeight, window.innerHeight)
    adjustAtfSticky(
      $('#product-featured-image-container'),
      $('#product-featured-image-container').els[0].clientHeight,
      window.innerHeight
    )
  }

  //what is this doing? It's is trying to use an undefined function i.e. adjustBuyboxTop()

  // const buyboxObserver = new ResizeObserver((entries) => {
  //   for (let entry of entries) {
  //     adjustBuyboxTop(entry.target.clientHeight, window.innerHeight)
  //   }
  // })
  // buyboxObserver.observe($('.js-sticky-buybox').els[0])

  window.MicroBus.on(`variant:change`, (e) => {
    const variantId = e.detail

    if (!variants?.length) {
      return
    }

    const currentVariant = window.allVariants.find((variant) => parseInt(variant.id) === parseInt(variantId))
    const threeMonthCurrentVariant = allVariants.find(
      (variant) => currentVariant.title === variant.title && variant.name.includes('3 Month Supply')
    )
    const outOfStock = getOutOfStockData(variantId)
    const atcButtons = $('.js-current-variant-id')
    $('[data-selected-variant-id]').attr('data-selected-variant-id', variantId)
    $('#product-above-fold').find('[data-scroll-track]').removeClass('tw-scroll-track')
    if (threeMonthCurrentVariant) {
      atcButtons.each((atcButton) => {
        atcButton.setAttribute('data-upsell-variant-id', threeMonthCurrentVariant.id)
      })
    }
    updateUrlWithVariantId(variantId)
    atcButtons.attr('data-variant-id', variantId)
    if (currentVariant.show_clinical_studies_accordion === true) {
      $('.js-clinical-studies-accordion').attr('aria-hidden', 'false')
    } else {
      $('.js-clinical-studies-accordion').attr('aria-hidden', 'true')
    }

    if (outOfStock) {
      atcButtons.each((atcButton) => atcButton.setAttribute('out-of-stock', ''))
      atcButtons.each((atcButton) => atcButton.setAttribute('klaviyo-form-id', outOfStock.formId))
      atcButtons.each((atcButton) => atcButton.setAttribute('disable-cart-toggle', ''))
    } else {
      atcButtons.each((atcButton) => atcButton.removeAttribute('out-of-stock'))
      atcButtons.each((atcButton) => atcButton.removeAttribute('klaviyo-form-id'))
      atcButtons.each((atcButton) => atcButton.removeAttribute('disable-cart-toggle'))
    }

    //update featured image
    const featuredImages = $('.js-featured-image').els
    for (let i = 0; i < featuredImages.length; i++) {
      if (featuredImages[i].getAttribute('data-variant-id') == variantId) {
        featuredImages[i].classList.add('tw-flex')
        featuredImages[i].classList.remove('tw-hidden')
      } else {
        featuredImages[i].classList.remove('tw-flex')
        featuredImages[i].classList.add('tw-hidden')
      }
    }

    //update variant icons
    $('.js-featured-image-icon').els.forEach((el) => {
      if (el.getAttribute('data-variant-id') == variantId) {
        el.classList.add('tw-flex')
        el.classList.remove('tw-hidden')
      } else {
        el.classList.remove('tw-flex')
        el.classList.add('tw-hidden')
      }
    })

    //update variant images
    $('.js-variant-image').els.forEach((el) => {
      if (el.getAttribute('data-variant-id') == variantId) {
        el.classList.remove('tw-hidden')
        el.classList.add('tw-flex')
        // Also show parent video container if it exists
        const videoContainer = el.closest('[data-video]')
        if (videoContainer) {
          videoContainer.setAttribute('aria-hidden', 'false')
        }
      } else {
        el.classList.remove('tw-flex')
        el.classList.add('tw-hidden')
        // Also hide parent video container if it exists
        const videoContainer = el.closest('[data-video]')
        if (videoContainer) {
          videoContainer.setAttribute('aria-hidden', 'true')
        }
      }
    })

    //update gallery images
    const galleryImageContainers = $('.js-product-gallery').els
    for (let i = 0; i < galleryImageContainers.length; i++) {
      if (galleryImageContainers[i].getAttribute('data-gallery-variant-id') == variantId) {
        galleryImageContainers[i].classList.add('tw-flex')
        galleryImageContainers[i].classList.remove('tw-hidden')
      } else {
        galleryImageContainers[i].classList.remove('tw-flex')
        galleryImageContainers[i].classList.add('tw-hidden')
      }
    }

    //send update gallery event
    window.MicroBus.emit(`variant:update-gallery`)

    //update price
    let currentPrice = currentVariant?.price
    let showStrikeout = false
    // check atc button to see if there is a selling plan
    if (
      currentVariant?.selling_plan_allocations[0]?.selling_plan_id == $('add-button#AddToCart').attr('data-selling-plan-id')
    ) {
      currentPrice = currentVariant?.selling_plan_allocations[0]?.price
    }
    if (window.sitewide_sale?.enabled && window.sitewide_sale.product_types == 'any') {
      currentPrice = Math.round(currentPrice - (window.sitewide_sale?.discount / 100) * currentPrice)
      showStrikeout = true
    } else if (
      window.sitewide_sale?.enabled &&
      window.sitewide_sale.product_types == 'subscription' &&
      currentVariant?.selling_plan_allocations[0]?.selling_plan_id == $('add-button#AddToCart').attr('data-selling-plan-id')
    ) {
      currentPrice = Math.round(currentPrice - (window.sitewide_sale?.discount / 100) * currentPrice)
      showStrikeout = true
    }

    const isMonthlyOnly = document.querySelector(`#product-above-fold`).getAttribute('data-monthly-only') == 'true'

    if (isMonthlyOnly) {
      $('.js-monthly-only-price').attr('data-variant-id', variantId)
      $('.js-monthly-only-price').html(`${outOfStock ? '' : '$' + centsToDollars(currentVariant?.price) + '/month'}`)
      $('.js-per-day-cost').text('($' + centsToDollars(currentVariant?.price / 30) + '/ day)')
    }

    if (showStrikeout) {
      $('.js-price').html(
        `${
          outOfStock
            ? ''
            : '&nbsp;— $' +
              centsToDollars(currentPrice) +
              ' <s>$' +
              centsToDollars(currentVariant?.compare_at_price || currentVariant?.price)
        }`
      )
    } else {
      $('.js-price').html(`${outOfStock ? '' : '&nbsp;— $' + centsToDollars(currentPrice)}`)
    }
    $('.js-compare-price').html(`${outOfStock ? '' : '$' + centsToDollars(currentVariant?.compare_at_price)}`)

    //update atc text
    $('.js-atc-text').html(
      `${outOfStock ? `${outOfStock.buttonText ? outOfStock.buttonText : 'Notify Me When Back In Stock'}` : 'Add to Cart'}`
    )

    StampedFn?.reloadUGC()
  })

  window.MicroBus.on(`variant:change-prenatal`, (e) => {
    const currentVariantId = document.querySelector(`#product-above-fold`).getAttribute('data-variant-id')
    const currentVariant = variants.find((variant) => variant.id == currentVariantId)
    const prenatalPosition = product.options.findIndex((option) => option == 'Prenatal Type')
    const prenatalPositionStr = `option${prenatalPosition + 1}`

    let prenatalType = 'Powder'
    if (e.detail == 'prenatal-multi-powder') {
      prenatalType = 'Powder'
    } else if (e.detail == 'prenatal-multi-capsules') {
      prenatalType = 'Capsules'
    } else if (e.detail == 'prenatal-multi-essentials') {
      prenatalType = 'Essentials'
    }

    let newVariantTitle = createNewVariantTitle(currentVariant, prenatalPositionStr, prenatalType)
    let newVariant = variants.find((variant) => variant.title.toLowerCase() == newVariantTitle.toLowerCase())

    if (!newVariant) {
      const scentPosition = product.options.findIndex((option) => option == 'Scent')
      const matchedOption = currentVariant.options.find(
        (option, index) => index != prenatalPosition && index != scentPosition
      )
      newVariant = variants.find(
        ({ title }) =>
          title.toLowerCase().includes(prenatalType.toLowerCase()) &&
          title.toLowerCase().includes(matchedOption.toLowerCase())
      )
    }

    window.MicroBus.emit(`variant:change`, newVariant.id)
  })

  window.MicroBus.on(`variant:change-omega`, (e) => {
    const currentVariantId = document.querySelector(`#product-above-fold`).getAttribute('data-variant-id')
    const isMonthlyOnly = document.querySelector(`#product-above-fold`).getAttribute('data-monthly-only')
    let currentVariant
    let currentDeliverySchedule
    let sellingPlanId = ''
    if (isMonthlyOnly == 'false') {
      currentDeliverySchedule = $('[data-dropdown-button-type="delivery"] li.selected')?.attr('data-selling-plan-months')
      const currentDeliveryVariantId = $('[data-dropdown-button-type="delivery"] li.selected')?.attr(
        `data-variant-id-${e.detail.omegaHandle}`
      )
      switch (currentDeliverySchedule) {
        case '1':
          currentVariant = variants.find((variant) => variant.id == currentDeliveryVariantId)
          sellingPlanId = currentVariant?.selling_plan_allocations[0].selling_plan_id
          break
        case '3':
          currentVariant = threeMonthVariants.find((variant) => variant.id == currentDeliveryVariantId)
          sellingPlanId = currentVariant?.selling_plan_allocations[0].selling_plan_id
          break
        case '6':
          currentVariant = sixMonthVariants.find((variant) => variant.id == currentDeliveryVariantId)
          sellingPlanId = currentVariant?.selling_plan_allocations[0].selling_plan_id
          break
        case '9':
          currentVariant = nineMonthVariants.find((variant) => variant.id == currentDeliveryVariantId)
          sellingPlanId = currentVariant?.selling_plan_allocations[0].selling_plan_id
          break
        case '0':
          currentVariant = variants.find((variant) => variant.id == currentDeliveryVariantId)
          sellingPlanId = ''
      }
    } else {
      currentVariant = variants.find((variant) => variant.id == currentVariantId)
    }
    let newVariantTitle = createNewVariantTitle(currentVariant, e.detail.optionPosition, e.detail.omegaType)
    let newVariant = variants.find((variant) => variant.title.toLowerCase() == newVariantTitle.toLowerCase())

    const oneTimePurchaseButton = document.querySelector('[data-is-onetime-button]')
    if (oneTimePurchaseButton) {
      const findVariantByHandle = (variantList, handle) =>
        variantList.find((variant) => handlize(variant.title.toLowerCase()).includes(handle.toLowerCase()))

      const oneTimePurchaseVariant = findVariantByHandle(variants, e.detail.omegaHandle)
      if (oneTimePurchaseVariant) {
        oneTimePurchaseButton.setAttribute('data-variant-id', oneTimePurchaseVariant.id)
      } else {
        oneTimePurchaseButton.setAttribute('data-variant-id', '')
      }

      const threeMonthVariant = findVariantByHandle(threeMonthVariants, e.detail.omegaHandle)
      if (threeMonthVariant) {
        oneTimePurchaseButton.setAttribute('data-upsell-variant-id', threeMonthVariant.id)
      } else {
        oneTimePurchaseButton.setAttribute('data-upsell-variant-id', '')
      }
    }

    window.MicroBus.emit(`variant:change`, newVariant.id)
    //change selling plan if not monthly only
    if (isMonthlyOnly == 'false') {
      window.MicroBus.emit(`variant:selling-plan-change`, {
        variantId: currentVariant.id,
        selling_plan: sellingPlanId,
        price: currentVariant.selling_plan_allocations[0].price,
        selling_plan_months: currentDeliverySchedule,
      })
    }
  })

  const initOTPOnetimeUpsellVariant = () => {
    const oneTimePurchaseButton = document.querySelector('[data-is-onetime-button]')
    if (oneTimePurchaseButton) {
      const currentVariantId = document.querySelector(`#product-above-fold`).getAttribute('data-variant-id')
      if (!currentVariantId) {
        return
      }

      const currentVariant = window.allVariants.find((variant) => variant.id === currentVariantId)
      let threeMonthVariant
      if (currentVariant) {
        threeMonthVariant = threeMonthVariants.find((variant) => {
          return (
            variant.option1 === currentVariant.option1 &&
            variant.option2 === currentVariant.option2 &&
            variant.option3 === currentVariant.option3
          )
        })
      }
      if (threeMonthVariant) {
        oneTimePurchaseButton.setAttribute('data-upsell-variant-id', threeMonthVariant.id)
      } else {
        oneTimePurchaseButton.setAttribute('data-upsell-variant-id', '')
      }
    }
  }

  const createNewVariantTitle = (currentVariant, positionStr, newVariantOptionStr) => {
    let newVariantTitle
    switch (positionStr) {
      case 'option1':
        newVariantTitle = `${newVariantOptionStr}`
        if (currentVariant?.option2) {
          newVariantTitle += ` / ${currentVariant?.option2}`
        }
        if (currentVariant?.option3) {
          newVariantTitle += ` / ${currentVariant.option3}`
        }
        break
      case 'option2':
        newVariantTitle = `${currentVariant.option1}` + ` / ${newVariantOptionStr}`
        if (currentVariant?.option3) {
          newVariantTitle += ` / ${currentVariant?.option3}`
        }
        break
      case 'option3':
        newVariantTitle = `${currentVariant?.option1}` + ` / ${currentVariant?.option2} / ${newVariantOptionStr}`
        break
    }
    return newVariantTitle
  }

  const getCurrentVariantDataBySchedule = (currentDeliverySchedule) => {
    let currentVariants = []
    switch (currentDeliverySchedule) {
      case '0':
        currentVariants = product.variants
        break
      case '1':
        currentVariants = product.variants
        break
      case '3':
        currentVariants = threeMonthVariants
        break
      case '6':
        currentVariants = sixMonthVariants
        break
      case '9':
        currentVariants = nineMonthVariants
        break
    }
    return currentVariants
  }

  window.MicroBus.on(`product:html-replaced`, (e) => {
    addUpsellButtonListeners()
  })

  window.MicroBus.on(`variant:change-hydration`, (e) => {
    const currentVariantId = document.querySelector(`#product-above-fold`).getAttribute('data-variant-id')
    const currentVariant = variants.find((variant) => variant.id == currentVariantId)
    const hydrationFlavorPosition = product.options.findIndex((option) => option == 'Hydration Flavor')
    const hydrationFlavorPositionStr = `option${hydrationFlavorPosition + 1}`

    let flavorType = 'Variety Pack'
    if (e.detail == 'hydration-support') {
      flavorType = 'Lemon'
    } else if (e.detail == 'hydration-support-lime') {
      flavorType = 'Lime'
    } else if (e.detail == 'hydration-support-variety') {
      flavorType = 'Variety Pack'
    } else if (e.detail == 'hydration-support-grapefruit') {
      flavorType = 'Grapefruit'
    }

    let newVariantTitle = createNewVariantTitle(currentVariant, hydrationFlavorPositionStr, flavorType)
    let newVariant = variants.find((variant) => variant.title.toLowerCase() == newVariantTitle.toLowerCase())

    window.MicroBus.emit(`variant:change`, newVariant.id)
  })

  window.MicroBus.on(`variant:change-selector`, (e) => {
    const { variantId, selling_plan } = e.detail
    $('add-button').els.forEach((el) => {
      if (el.hasAttribute('data-is-onetime-button')) {
        $(el).attr('data-selling-plan-id', '')
      } else {
        $(el).attr('data-selling-plan-id', selling_plan)
      }
    })
    $('add-button').attr('data-variant-id', variantId)
  })

  window.MicroBus.on(`variant:selling-plan-change`, (e) => {
    const { variantId, productId, selling_plan, price, selling_plan_months } = e.detail
    const outOfStock = getOutOfStockData()
    let currentPrice = Number(price)
    let showStrikeout = false
    if (window.sitewide_sale?.enabled && window.sitewide_sale.product_types == 'any') {
      currentPrice = Math.round(currentPrice - (window.sitewide_sale?.discount / 100) * currentPrice)
      showStrikeout = true
    } else if (
      window.sitewide_sale?.enabled &&
      window.sitewide_sale.product_types == 'subscription' &&
      selling_plan_months >= 1
    ) {
      currentPrice = Math.round(currentPrice - (window.sitewide_sale?.discount / 100) * currentPrice)
      showStrikeout = true
    }

    $('.js-current-variant-id[data-variant-id]').attr('data-variant-id', variantId)
    $('.js-current-variant-id[data-product-id]').attr('data-product-id', productId)
    $('.js-current-selling-plan-id[data-selling-plan-id]').attr('data-selling-plan-id', selling_plan)
    $('.js-current-selling-plan-id[data-selling-plan-months]').attr('data-selling-plan-months', selling_plan)
    $('.js-is-selling-plan[data-is-selling-plan]').attr('data-is-selling-plan', selling_plan ? 'true' : 'false')

    if (showStrikeout) {
      $('.js-price').html(
        `${outOfStock ? '' : '&nbsp;— $' + centsToDollars(currentPrice) + ' <s>$' + centsToDollars(price) + '</s>'}`
      )
    } else {
      $('.js-price').html(`${outOfStock ? '' : '&nbsp;— $' + centsToDollars(currentPrice)}`)
    }

    $('add-button').els.forEach((el) => {
      if (el.hasAttribute('data-is-onetime-button')) {
        $(el).attr('data-selling-plan-id', '')
      } else {
        $(el).attr('data-selling-plan-id', selling_plan)
      }
    })
    $('[data-is-one-time]').attr('data-is-one-time', selling_plan ? 'false' : 'true')

    // Update variant selector
    const currentVariants = getCurrentVariantDataBySchedule(selling_plan_months)
    const optionInputs = $('[data-option-selector="Scent"] input').els

    for (let i = 0; i < currentVariants.length; i++) {
      const variant = currentVariants[i]
      for (let j = 0; j < optionInputs.length; j++) {
        if (
          optionInputs[j].getAttribute('data-handle') == handlize(variant.title) &&
          optionInputs[j].getAttribute('data-variant-id') == variant.id
        ) {
          const optionInput = optionInputs[j]
          $(optionInput).attr('data-variant-id', variant.id)
          $(optionInput).attr(
            'data-selling-plan-id',
            selling_plan_months > 0 ? variant.selling_plan_allocations[0].selling_plan_id : ''
          )
          $(optionInput).attr('data-selling-plan-price', variant.selling_plan_allocations[0].price)
          $(optionInput).attr('data-selling-plan-months', selling_plan_months)
          $(optionInput).attr('value', variant.id)
        }
      }
    }

    window.MicroBus.emit('variant:change', variantId)

    if (selling_plan_months == 1) {
      $('add-button .igPrice').attr('data-price-multiplier', '.9')
    } else {
      $('add-button .igPrice').attr('data-price-multiplier', '1')
    }
  })

  window.MicroBus.emit(`window:pdp-js-ready`)
  initOTPOnetimeUpsellVariant()
})
